import * as React from "react";
import Ifix2 from "../Images/ifix2.png";
import Ifix3 from "../Images/ifix3.png";
import Ifix4 from "../Images/ifix4.png";
import Ifix5 from "../Images/ifix5.png";
import Ifix6 from "../Images/ifix6.png";

function Section2() {
  return (
    <div className="flex flex-col py-10 items-center px-5">
      <div className="text-lg font-bold leading-7 text-cyan-700 uppercase">
        Our Portfolio
      </div>
      <div className="mt-0 text-5xl font-semibold tracking-wide text-center capitalize leading-[52.08px] text-zinc-800 max-md:max-w-full">
        Our Successive Projects{" "}
      </div>
      <div className="flex flex-col self-stretch px-16 mt-8 w-full max-md:px-5 max-md:mt-10 max-md:max-w-full">
        <div className="max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col justify-center pb-8 w-full text-base leading-6 bg-white rounded-md border border-solid border-neutral-900 border-opacity-10 max-md:mt-8">
                <img
                  loading="lazy"
                  src={Ifix2}
                  className="w-full border-b border-solid aspect-[1.39] border-neutral-900 border-opacity-10"
                />
                <div className="flex flex-col p-6 max-md:px-5">
                  <div className="flex gap-4 self-start text-sm font-medium">
                    <div className="justify-center px-2 py-1 text-white bg-cyan-700 rounded-sm">
                      Solar{" "}
                    </div>
                    <div className="my-auto text-cyan-700">5 min read</div>
                  </div>
                  <div className="mt-4 text-2xl font-bold leading-8 text-neutral-900">
                    What is Solar Panel?
                  </div>
                  <div className="mt-2 leading-6 text-neutral-900">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros.
                  </div>
                  <div className="flex gap-1 justify-center self-start px-4 py-2 mt-6 rounded-sm border border-solid border-neutral-900 text-neutral-900">
                    <div>Read more</div>
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/76a971a561d4b4fdaed553111253ab1a03b2063d91f6a81d852d86daebf0ce6d?"
                      className="shrink-0 my-auto w-4 aspect-square"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow w-full text-base leading-6 bg-white rounded-md border border-solid border-neutral-900 border-opacity-10 max-md:mt-8">
                <img
                  loading="lazy"
                  src={Ifix3}
                  className="w-full aspect-[1.39]"
                />
                <div className="flex flex-col p-6 max-md:px-5">
                  <div className="flex gap-4 self-start text-sm font-medium">
                    <div className="justify-center px-2 py-1 text-white whitespace-nowrap bg-cyan-700 rounded-sm">
                      Solar
                    </div>
                    <div className="my-auto text-cyan-700">5 min read</div>
                  </div>
                  <div className="mt-4 text-2xl font-bold leading-8 text-neutral-900">
                    How can we put solar panel into the roof?
                  </div>
                  <div className="mt-2 leading-6 text-neutral-900">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros.
                  </div>
                  <div className="flex gap-1 justify-center self-start px-4 py-2 mt-6 rounded-sm border border-solid border-neutral-900 text-neutral-900">
                    <div>Read more</div>
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/76a971a561d4b4fdaed553111253ab1a03b2063d91f6a81d852d86daebf0ce6d?"
                      className="shrink-0 my-auto w-4 aspect-square"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow w-full text-base leading-6 bg-white rounded-md border border-solid border-neutral-900 border-opacity-10 max-md:mt-8">
                <img
                  loading="lazy"
                  src={Ifix4}
                  className="w-full border-b border-solid aspect-[1.39] border-neutral-900 border-opacity-10"
                />
                <div className="flex flex-col p-6 max-md:px-5">
                  <div className="flex gap-4 self-start text-sm font-medium">
                    <div className="justify-center px-2 py-1 text-white whitespace-nowrap bg-cyan-700 rounded-sm">
                      Solar
                    </div>
                    <div className="my-auto text-cyan-700">5 min read</div>
                  </div>
                  <div className="mt-4 text-2xl font-bold leading-8 text-neutral-900">
                    Guide to buy an Solar Panel for your house
                  </div>
                  <div className="mt-2 leading-6 text-neutral-900">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros.
                  </div>
                  <div className="flex gap-1 justify-center self-start px-4 py-2 mt-6 rounded-sm border border-solid border-neutral-900 text-neutral-900">
                    <div>Read more</div>
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/76a971a561d4b4fdaed553111253ab1a03b2063d91f6a81d852d86daebf0ce6d?"
                      className="shrink-0 my-auto w-4 aspect-square"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 max-md:mt-10 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow pb-8 w-full text-base leading-6 bg-white rounded-md border border-solid border-neutral-900 border-opacity-10 max-md:mt-8">
                <img
                  loading="lazy"
                  src={Ifix5}
                  className="w-full border-b border-solid aspect-[1.39] border-neutral-900 border-opacity-10"
                />
                <div className="flex flex-col p-6 max-md:px-5">
                  <div className="flex gap-4 self-start text-sm font-medium">
                    <div className="justify-center px-2 py-1 text-white whitespace-nowrap bg-cyan-700 rounded-sm">
                      Solar
                    </div>
                    <div className="my-auto text-cyan-700">5 min read</div>
                  </div>
                  <div className="mt-4 text-2xl font-bold leading-8 text-neutral-900">
                    How much price for Solar in USA?
                  </div>
                  <div className="mt-2 leading-6 text-neutral-900">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros.
                  </div>
                  <div className="flex gap-1 justify-center self-start px-4 py-2 mt-6 rounded-sm border border-solid border-neutral-900 text-neutral-900">
                    <div>Read more</div>
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/4466a259f8452e46e80ac8afa2f428c16b3870a304b3203ca3b7297737dfda72?"
                      className="shrink-0 my-auto w-4 aspect-square"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow w-full text-base leading-6 bg-white rounded-md border border-solid border-neutral-900 border-opacity-10 max-md:mt-8">
                <img
                  loading="lazy"
                  src={Ifix4}
                  className="w-full border-b border-solid aspect-[1.39] border-neutral-900 border-opacity-10"
                />
                <div className="flex flex-col p-6 max-md:px-5">
                  <div className="flex gap-4 self-start text-sm font-medium">
                    <div className="justify-center px-2 py-1 text-white whitespace-nowrap bg-cyan-700 rounded-sm">
                      Solar
                    </div>
                    <div className="my-auto text-cyan-700">5 min read</div>
                  </div>
                  <div className="mt-4 text-2xl font-bold leading-8 text-neutral-900">
                    How Solar Panel will Save our House Electricity
                  </div>
                  <div className="mt-2 leading-6 text-neutral-900">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros.
                  </div>
                  <div className="flex gap-1 justify-center self-start px-4 py-2 mt-6 rounded-sm border border-solid border-neutral-900 text-neutral-900">
                    <div>Read more</div>
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/4466a259f8452e46e80ac8afa2f428c16b3870a304b3203ca3b7297737dfda72?"
                      className="shrink-0 my-auto w-4 aspect-square"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow w-full text-base leading-6 bg-white rounded-md border border-solid border-neutral-900 border-opacity-10 max-md:mt-8">
                <img
                  loading="lazy"
                  src={Ifix6}
                  className="w-full border-b border-solid aspect-[1.39] border-neutral-900 border-opacity-10"
                />
                <div className="flex flex-col p-6 max-md:px-5">
                  <div className="flex gap-4 self-start text-sm font-medium">
                    <div className="justify-center px-2 py-1 text-white bg-cyan-700 rounded-sm">
                      Solar{" "}
                    </div>
                    <div className="my-auto text-cyan-700">5 min read</div>
                  </div>
                  <div className="mt-4 text-2xl font-bold leading-8 text-neutral-900">
                    Is there any Benefits of Using Solar Panel for our House?
                  </div>
                  <div className="mt-2 leading-6 text-neutral-900">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros.
                  </div>
                  <div className="flex gap-1 justify-center self-start px-4 py-2 mt-6 rounded-sm border border-solid border-neutral-900 text-neutral-900">
                    <div>Read more</div>
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/eb9a08e926ca7c0b59700f0a2ce5a47307778a84b27e34d354226cac0ec52f57?"
                      className="shrink-0 my-auto w-4 aspect-square"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section2;
